jQuery(document).ready(function() {


   //-------------------------- Carousel For Related Product ----------------------//
   setTimeout(function(){
  jQuery(".related").owlCarousel({
			loop: true,
			dots: false,
			margin: 30,
			nav: true,
			responsiveClass: true,
			responsive: {
				0: {
					items: 1
				},
				480: {
					items: 2
				},
				1024: {
					items: 4
				}
			}
		});
    },1000);
  

  
setTimeout(function() {
  
  jQuery(".header__icon--menu").on("click", function() {
        jQuery("html").toggleClass("res-menu-open")
    });
  },500);
    //--------------- Label according to language-----------------
    setTimeout(function() {
    if (jQuery('html').attr('lang') == 'de') {
        jQuery('.contact-title').text("KONTAKTIERE MICH");
        jQuery('.git-title').text("IN KONTAKT KOMMEN");
        jQuery('.cntct-dtl-tlt').text("KONTAKT");
        jQuery('.flw-tlt').text("Folge uns");
        jQuery('.last-name').html("Nachname");
        jQuery('.website').html("Webseite");
        jQuery('.conf-passs').html("Passwort bestätigen");
        jQuery('.alrdy-acc').html("Sie haben bereits ein Konto?");
        jQuery('.log-link').html("EINLOGGEN");
        jQuery('.page-width a.home-breadcrumb').text("Heim");
        jQuery('.prtnr-brdcrmb').text("Partners");
        jQuery('.cart-brdcmb').text("Wagen");
        jQuery('.my-acc').text("MEIN KONTO");
        jQuery('#customer_logout_link').text("AUSLOGGEN");
        jQuery('.rgstr-brdcrmb').text("Registrieren");
        jQuery('.member').text("Neues Mitglied?");
       // //     jQuery('.404-brdcmb').text("404 Fehler");
      }
  
    if (jQuery('html').attr('lang') == 'fr') {
        jQuery('.last-name').html("Nom de famille");
        jQuery('.website').html("site Internet");
        jQuery('.conf-passs').html("Confirmez De passe");
        jQuery('.alrdy-acc').html("Vous avez déjà un compte?");
        jQuery('.log-link').html("Connexion");
        jQuery('.contact-title').text("Contactez moi");
        jQuery('.git-title').text("ENTRER EN CONTACT");
        jQuery('.rgstr-brdcrmb').text("S'inscrire");
        jQuery('.flw-tlt').text("Suivez-nous");
        jQuery('.page-width a.home-breadcrumb').text("Maison");
        jQuery('.prtnr-brdcrmb').text("Les partenaires");
        jQuery('.cart-brdcmb').text("Chariot");
        jQuery('.my-acc').text("MON COMPTE");
        jQuery('#customer_logout_link').text("SE DÉCONNECTER");
        jQuery('.member').text("Nouveau membre?");
     //     $('.404-brdcmb').text("Erreur 404");
      }
    },500);
    
  
  //------------- Toggle password for register page -------------//
  jQuery(".toggle-conf-pass").on('click', function () {

		jQuery(this).toggleClass("fa-eye fa-eye-slash");
		var input = jQuery(jQuery(this).attr("toggle"));
		if (input.attr("type") == "password") {

			input.attr("type", "text");
		} else {

			input.attr("type", "password");
		}
	});
  
  //------------- Comment form Js ----------------//
  jQuery('.cmnt_btn').on('click',function(){
  		var fname=jQuery('#CommentForm-firstname').val();
    	var lname=jQuery('#CommentForm-lastname').val();
    	var email=jQuery('#CommentForm-email').val();
        var comment=jQuery('#CommentForm-cmnt').val();
        var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
		
    	var fflag=0,lflag=0,eflag=0,cflag=0;
    	 
		if(fname == "")
        {
          	jQuery('.error-fname').show();
        	jQuery('#CommentForm-firstname').addClass('input--error');
          	jQuery('.error-fname').text("Please enter your first name.");
            if ($('html').attr('lang') == 'de') {
               $('.error-fname').text("Bitte geben Sie Ihren Vornamen ein.");
        	}
          if ($('html').attr('lang') == 'fr') {
                $('.error-fname').text("Entrez votre prénom s'il vous plait");
           }
            
        	fflag=1;
        }
    	else
        {
			jQuery('.error-fname').hide();
        	jQuery('#CommentForm-firstname').removeClass('input--error');
        }
    	if(lname == "")
        {
        	jQuery('.error-lname').show();
          	jQuery('#CommentForm-lastname').addClass('input--error');
          	jQuery('.error-lname').text("Please enter your last name.");
            if ($('html').attr('lang') == 'de') {
               $('.error-lname').text("Bitte geben Sie ihren Nachnamen ein.");
        	}
          if ($('html').attr('lang') == 'fr') {
                $('.error-lname').text("Veuillez entrer votre nom de famille.");
             }
          	lflag=1;
        }
    	else
        {
			jQuery('.error-lname').hide();
        	jQuery('#CommentForm-lastname').removeClass('input--error');
        }
    	
    	if(email == '')
        {
            emailflag=1;
          	jQuery('.error-email').show();
        	jQuery('#CommentForm-email').addClass('input--error');
          	jQuery('.error-email').text('Please enter your email address.');
            if ($('html').attr('lang') == 'de') {
               $('.error-email').text("Geben Sie bitte Ihre Email-Adresse ein.");
        	}
          if ($('html').attr('lang') == 'fr') {
                $('.error-email').text("Veuillez saisir votre adresse e-mail.");
             }
        }
    	else
        {
        	   if(!email.match(test_pattern))
            {
                emailflag=1;           
                jQuery('.error-email').show();
                jQuery('#CommentForm-email').addClass('input--error');
                jQuery('.error-email').text('Please enter your valid email address.');
                if ($('html').attr('lang') == 'de') {
                 $('.error-email').text("Bitte geben Sie Ihre gültige E-Mail-Adresse ein.");
            	}
              if ($('html').attr('lang') == 'fr') {
                $('.error-email').text("Entrez une adresse courriel valide s'il-vous-plaît.");
             }
            }
          	else
            {
            	jQuery('.error-email').hide();
                jQuery('#CommentForm-email').removeClass('input--error');
            }
        }
    	
    if(comment == "")
        {
        	jQuery('.error-comment').show();
          	jQuery('#CommentForm-cmnt').addClass('input--error');
          	jQuery('.error-comment').text("Please enter your message.");
            if ($('html').attr('lang') == 'de') {
               $('.error-comment').text("Bitte gib deine Nachricht ein.");
        	}
            if ($('html').attr('lang') == 'fr') {
                $('.error-comment').text("Veuillez entrer votre message.");
             }
          	cflag=1;
        }
    	else
        {
			jQuery('.error-comment').hide();
        	jQuery('#CommentForm-cmnt').removeClass('input--error');
        }
    	
    	if(fflag==1 || lflag==1 || eflag==1 || cflag==1 )
        {
            
        	jQuery('.error-all').show();
          	jQuery('.error-all').html("One or more fields have an error. Please check and try again.");
            if ($('html').attr('lang') == 'de') {
                $('.error-all').text("Ein oder mehrere Felder weisen einen Fehler auf. Bitte prüfen und erneut versuchen.");
             }
            if ($('html').attr('lang') == 'fr') {
                $('.error-all').text("Un ou plusieurs champs contiennent une erreur. S'il vous plaît, vérifiez et essayez à nouveau.");
             }
          	return false;
        }
    	else
        {
        	jQuery('.error-all').hide();
          	return true;
        }
  });
  
  
  
// ====add-address-page=====
jQuery(".add-new-button").click(function(){
jQuery("body").addClass("address-open-form");

});
jQuery(".add-cancle-address-form").click(function(){
jQuery("body").removeClass("address-open-form");

});
  
  // ====edit-address-page====
jQuery(".btn-custom-edit").click(function(){
jQuery("body").addClass("edit-open-form");

});
jQuery(".edit-cancle-address-form").click(function(){
jQuery("body").removeClass("edit-open-form");

});

// ====edit-address-one-open-another-close-js=====
 jQuery(".address-list ul li").click(function(){
    
    jQuery(".address-list ul li").each(function(){
        jQuery(this).removeClass("open-edit");
    });
    jQuery(this).addClass("open-edit");
});  
  
//===========detail page slick js  
$('.slider-for').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   fade: true,
   asNavFor: '.slider-nav'
 });
 $('.slider-nav').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   asNavFor: '.slider-for',
   dots: false,
   focusOnSelect: true,
   vertical: true,
   verticalSwiping: true,  
   responsive: [
    {
      breakpoint: 480,
      settings: {
      slidesToShow: 2,  
      slidesToScroll: 1  
      }
    }
   ]
 });
  
  
 
  
  
  //----- Add class on second span breadcrumb --------// 
  
  if (jQuery("body").hasClass("Partners")) {
            //console.log('fghf');
            jQuery(".breadcrumb span:nth-child(3)").addClass("prtnr-brdcrmb");
            }
  
  //----- Add class on last li in navigation menu --------// 
  jQuery(".header__inline-menu ul li:last-child").addClass('shop-button');
  
  //------------- Insta-feed Popup ----------------//
   setTimeout(function(){
  jQuery(".insta-feed").children('a').addClass("insta-pics");
     
     
     jQuery(document).on("click",".insta-pics",function(e){  
   	 $( "html" ).addClass( 'insta-popup');
	 });
     
     jQuery(document).on("click","#close-button-url",function(e){  
     $( "html" ).removeClass( 'insta-popup');
	 });
   },2500);

  
  //------------- remove-attribute ----------------//
  jQuery('.left-side a').removeAttr('title');
  
  //------------- Add class on title only for contaact page ----------//
  var loc = window.location.href; // returns the full URL
        if(/contact/.test(loc)) {
          jQuery(".default-title").addClass("contact-page");
        }
  
  //------------- NewsLetter Validation ----------------//
  
  jQuery('#Subscribe').on('click',function(e){

    var email = jQuery(".input_news").val(); 
    var flagemail=0;
    var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;

    if(email == "")
    {
      jQuery(".email-error").show();
      jQuery('.input_news').addClass('error');
      jQuery(".email-error").html("Please enter your email address.");
      if ($('html').attr('lang') == 'de') {
               $('.email-error').text("Geben Sie bitte Ihre Email-Adresse ein.");
        	}
      if ($('html').attr('lang') == 'fr') {
                $('.email-error').text("Veuillez saisir votre adresse e-mail.");
             }
      flagemail = 1 ;
    }
    else
    {
      if(!email.match(test_pattern))
      { 
        jQuery(".email-error").show();
        jQuery('.input_news').addClass('error');
        flagemail = 1 ;
        jQuery(".email-error").html("Please enter your valid email address."); 
        if ($('html').attr('lang') == 'de') {
                 $('.email-error').text("Bitte geben Sie Ihre gültige E-Mail-Adresse ein.");
            	}
              if ($('html').attr('lang') == 'fr') {
                $('.email-error').text("Entrez une adresse courriel valide s'il-vous-plaît.");
             }
      }
      else
      {
        jQuery(".email-error").hide();
        jQuery('.input_news').removeClass('error');
        flagemail = 0 ;
      }
    }

    if(flagemail == 1) 
    {  
      return false;	
    }
    else
    { 
      jQuery('.email-error').hide();
      return true;
    }

  });
  
//     function validateEmail($email) {
//       var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
//       return emailReg.test( $email );
//     }
//     jQuery('#Subscribe').on('click',function(){
//            var emailError = 0;
//           email = jQuery(".email-input").val();
//           jQuery("#newsletter-error-message").hide();
//           jQuery("#not-valid-tip").hide();

//            if(!email) {
//                 jQuery(".email-input").addClass('error');
//                 emailError = 1;
//             } else {
//                 if (validateEmail(email)) {
//                     jQuery(".email-input").removeClass('error');

//                 } else {
//                   console.log("else");
//                     jQuery('.email-input').addClass('error');
//                     emailrror = 1;
//                     var emailErrorMsg = '<span role="alert" id="not-valid-tip">Please enter a valid email address</span>';
//                     jQuery(emailErrorMsg).insertAfter('.email-erorr');
//                 }
//             }

//           if( emailError) {
//                var errorHTML = '<span id = "newsletter-error-message">Please enter your email address.</span>';
//                jQuery(errorHTML).insertAfter('.email-error');
//                console.log("email");
//              }
//     });
  
  
   //-------------------- Reset password form validation ------------------//

  	
  	jQuery('.reset_btn').on('click', function () {

		var res_passwd = jQuery("#ResetPassword").val();
		var con_passwd = jQuery("#PasswordConfirmation").val();
		var res_passwd_err = 0;
		var con_passwd_err = 0;
		if (res_passwd.trim() == "") {
			jQuery('.pass-error').show();
			res_passwd_err = 1;
			jQuery("#ResetPassword").addClass("input--error");
			jQuery('.pass-error').text("Please enter your password.");

		} else {
			res_passwd_err = 0;
			jQuery('.pass-error').hide();
			jQuery("#ResetPassword").removeClass("input--error");
		}

		if (con_passwd.trim() == "") {
			con_passwd_err = 1;
			jQuery('.confirm-pass-error').show();
			jQuery("#PasswordConfirmation").addClass("input--error");
			jQuery('.confirm-pass-error').text("Please enter your confirmation password.");
		} else if (res_passwd != con_passwd) {
			con_passwd_err = 2;
			jQuery("#ResetPassword").addClass("input--error");
			jQuery("#PasswordConfirmation").addClass("input--error");
          	jQuery('.confirm-pass-error').text("Please enter your right password.");
		} else {
			con_passwd_err = 0;
			jQuery("#ResetPassword").removeClass("input--error");
			jQuery("#PasswordConfirmation").removeClass("input--error");
			jQuery('.confirm-pass-error').hide();
		}


		if (res_passwd_err == 1 || con_passwd_err == 1) {
          
			jQuery('.error-all').show();
        	jQuery('.error-all').text('One or more fields have an error. Please check and try again.');  
        	return false;

		} else {
			if (con_passwd_err == 2) {

				jQuery(".error-all").text("Password and confirmation password does not match.");
				jQuery(".error-all").show();
				return false
                
                

			} else {
				
				jQuery(".error-all").hide();
				return true;
			}
		}
	}); 
  
  //-------------------- Edit address validation ------------------//
    jQuery('.editbutton').on("click",function(){
    
    	var fname=jQuery(this).closest("form").find('.AddressFirstName').val();
    	var lname=jQuery(this).closest("form").find('.AddressLastName').val();
  		
    	var address1=jQuery(this).closest("form").find('.address1').val();
    	var address2=jQuery(this).closest("form").find('.address2').val();  
    	
        var city=jQuery(this).closest("form").find('.address-city').val();
    	var zip=jQuery(this).closest("form").find('.address-zip').val();
    	var phone=jQuery(this).closest("form").find('.address-phone').val();
    	var fflag,lflag,add1flag,add2flag,cityflag,zipflag,phoneflag = 0;
    	//console.log(fname);
    	if(fname == "")
        {
          jQuery('.error-editfname').show();
          jQuery(this).closest("form").find('.AddressFirstName').addClass('input--error'); 
          jQuery('.error-editfname').text("Please enter your first name");
          if ($('html').attr('lang') == 'de') {
               $('.error-editfname').text("Bitte geben Sie Ihren Vornamen ein.");
        	}
            if ($('html').attr('lang') == 'fr') {
                $('.error-editfname').text("Entrez votre prénom s'il vous plait");
           }
            fflag=1;          
        }
    	else
        {  
             jQuery('.error-editfname').show();
        	 jQuery(this).closest("form").find('.AddressFirstName').removeClass('input--error');
          	
        	//jQuery('#AddressFirstNameNew').removeClass('has-error');
        }
    	if(lname == "")
        { 
          jQuery('.error-editlname').show();
          jQuery(this).closest("form").find('.AddressLastName').addClass('input--error');
          jQuery('.error-editlname').text("Please enter your last name.");
          if ($('html').attr('lang') == 'de') {
               $('.error-editlname').text("Bitte geben Sie ihren Nachnamen ein.");
        	}
          if ($('html').attr('lang') == 'fr') {
                $('.error-editlname').text("Veuillez entrer votre nom de famille.");
             }
            lflag=1;
        }
    	else
        {
          jQuery('.error-editlname').hide();
          jQuery(this).closest("form").find('.AddressLastName').removeClass('input--error');
        }
    
    	if(address1 == "")
        {
          jQuery('.error-editaddress').show();
          jQuery(this).closest("form").find('.address1').addClass('input--error');
          jQuery('.error-editaddress').text("Please enter your address.");
           if ($('html').attr('lang') == 'de') {
                $('.error-editaddress').text("Bitte geben Sie Ihre Adresse ein.");
             }
            if ($('html').attr('lang') == 'fr') {
                $('.error-editaddress').text("Veuillez entrer votre adresse.");
             }  
            add1flag=1;
        }
    	else
        {
          jQuery('.error-editaddress').hide();
        	jQuery(this).closest("form").find('.address1').removeClass('input--error');
        }
    	if(address2 == "")
        {
            jQuery('.error-editaddress2').show();
        	jQuery(this).closest("form").find('.address2').addClass('input--error');
            jQuery('.error-editaddress2').text("Please enter your Second address.");
          if ($('html').attr('lang') == 'de') {
                $('.error-editaddress2').text("Bitte geben Sie Ihre zweite Adresse ein.");
             }
             if ($('html').attr('lang') == 'fr') {
                $('.error-editaddress2').text("Veuillez entrer votre deuxième adresse.");
             }
            add2flag=1;
        }
    	else
        {
            jQuery('.error-editaddress2').hide();
        	jQuery(this).closest("form").find('.address2').removeClass('input--error');
        }
    	if(city == "")
        {
            jQuery('.error-editcity').show();
        	jQuery(this).closest("form").find('.address-city').addClass('input--error');
          jQuery('.error-editcity').text("Please enter your city.");
          if ($('html').attr('lang') == 'de') {
                $('.error-editcity').text("Bitte geben Sie Ihre Stadt ein.");
             }
            if ($('html').attr('lang') == 'fr') {
                $('.error-editcity').text("Veuillez entrer votre ville.");
             }
            cityflag=1;
        }
    	else
        {
            jQuery('.error-editcity').hide();
        	jQuery(this).closest("form").find('.address-city').removeClass('input--error');
        }   
     
   		 if(zip == "")
        {
            jQuery('.error-editzip').show();
        	jQuery(this).closest("form").find('.address-zip').addClass('input--error');
            jQuery('.error-editzip').text("Please enter your zip code.");
          if ($('html').attr('lang') == 'de') {
                $('.error-editzip').text("Bitte geben Sie Ihre Postleitzahl ein.");
             }
            if ($('html').attr('lang') == 'fr') {
                $('.error-editzip').text("S'il vous plait, entrer votre code postal.");
             }
            zipflag=1;
        }
    	else
        {
            jQuery('.error-editzip').hide();
        	jQuery(this).closest("form").find('.address-zip').removeClass('input--error');
        }
    	 if(phone == "")
        {
            jQuery('.error-editphone').show();
        	jQuery(this).closest("form").find('.address-phone').addClass('input--error');
            jQuery('.error-editphone').text("Please enter your contact number.");
           if ($('html').attr('lang') == 'de') {
                $('.error-editphone').text("Bitte gib deine Telefonnummer ein.");
             }
          if ($('html').attr('lang') == 'fr') {
                $('.error-editphone').text("Veuillez entrer votre numéro de téléphone.");
             }
            phoneflag=1;
        }
    	else
        {
            jQuery('.error-editphone').hide();
        	jQuery(this).closest("form").find('.address-phone').removeClass('input--error');
        }
    	
  		if(fflag == 1 || lflag == 1 || add1flag == 1 || add2flag == 1 || cityflag == 1 || zipflag == 1 || phoneflag == 1)
        {
          
        	jQuery('.error-all').show();
        	jQuery('.error-all').text('One or more fields have an error. Please check and try again.');  
          if ($('html').attr('lang') == 'de') {
                $('.error-all').text("Ein oder mehrere Felder weisen einen Fehler auf. Bitte prüfen und erneut versuchen.");
             }
            if ($('html').attr('lang') == 'fr') {
                $('.error-all').text("Un ou plusieurs champs contiennent une erreur. S'il vous plaît, vérifiez et essayez à nouveau.");
             }
        	return false;
        } 
     	else
        {
          jQuery('.error-all').hide();
          
        }
    	
  });
  jQuery('.edit-cancle-address-form').on('click',function(){

    jQuery('.edit-error-all').hide();
    jQuery('.address-phone').removeClass('input--error');
    jQuery('.error-editphone').hide();
    jQuery('.address-zip').removeClass('input--error');
    jQuery('.error-editzip').hide();
    jQuery('.address-city').removeClass('input--error');
    jQuery('.error-editcity').hide();
    jQuery('.address2').removeClass('input--error');
    jQuery('.error-editaddress2').hide();
    jQuery('.address1').removeClass('input--error');
    jQuery('.error-editaddress').hide();
    jQuery('.edit-companies').removeClass('input--error');
    jQuery('.error-edicompany').hide();
    jQuery('.AddressLastName').removeClass('input--error');
    jQuery('.error-editlname').hide();
    jQuery('.AddressFirstName').removeClass('input--error'); 
    jQuery('.error-editfname').hide();
    jQuery('html').removeClass('open_edit_form');
  });
  
  
  
   jQuery('.edit_btn').on('click', function () {
    jQuery('html').addClass('open_edit_form');
	});
  
//----------------  Add New Address Form validation ------------------  
  
  jQuery('.btn-add-addresses').on('click',function(){
  		var fname=jQuery('#AddressFirstNameNew').val();
    	var lname=jQuery('#AddressLastNameNew').val();
    	var add=jQuery('#AddressAddress1New').val();
    	var add2=jQuery('#AddressAddress2New').val();
    	var city=jQuery('#AddressCityNew').val();
    	var zip=jQuery('#AddressZipNew').val();
    	var phone=jQuery('#AddressPhoneNew').val();
    	// var company=jQuery('#AddressCompanyNew').val();
		
    	var fflag=0,lflag=0,addflag=0,add2flag=0,cityflag=0,zipflag=0,phoneflag=0;
    	 
		if(fname == "")
        {
          	jQuery('.error-fname').show();
        	jQuery('#AddressFirstNameNew').addClass('input--error');
          	jQuery('.error-fname').text("Please enter your first name.");
            if ($('html').attr('lang') == 'de') {
               $('.error-fname').text("Bitte geben Sie Ihren Vornamen ein.");
        	}
            if ($('html').attr('lang') == 'fr') {
                $('.error-fname').text("Entrez votre prénom s'il vous plait");
           }
        	fflag=1;
        }
    	else
        {
			jQuery('.error-fname').hide();
        	jQuery('#AddressFirstNameNew').removeClass('input--error');
        }
    	if(lname == "")
        {
        	jQuery('.error-lname').show();
          	jQuery('#AddressLastNameNew').addClass('input--error');
          	jQuery('.error-lname').text("Please enter your last name.");
           if ($('html').attr('lang') == 'de') {
               $('.error-lname').text("Bitte geben Sie ihren Nachnamen ein.");
        	}
            if ($('html').attr('lang') == 'fr') {
                $('.error-lname').text("Veuillez entrer votre nom de famille.");
             }
          	lflag=1;
        }
    	else
        {
			jQuery('.error-lname').hide();
        	jQuery('#AddressLastNameNew').removeClass('input--error');
        }
    	if(add == "")
        {
        	jQuery('.error-add1').show();
          	jQuery('#AddressAddress1New').addClass('input--error');
          	jQuery('.error-add1').text("Please enter your address.");
          if ($('html').attr('lang') == 'de') {
                $('.error-add1').text("Bitte geben Sie Ihre Adresse ein.");
             }
          if ($('html').attr('lang') == 'fr') {
                $('.error-add1').text("Veuillez entrer votre adresse.");
             }
          	addflag=1;
        }
    	else
        {
			jQuery('.error-add1').hide();
        	jQuery('#AddressAddress1New').removeClass('input--error');
        }
    	
    	if(add2 == "")
        {
        	jQuery('.error-add2').show();
          	jQuery('#AddressAddress2New').addClass('input--error');
          	jQuery('.error-add2').text("Please enter your second address.");
           if ($('html').attr('lang') == 'de') {
                $('.error-add2').text("Bitte geben Sie Ihre zweite Adresse ein.");
             }
          if ($('html').attr('lang') == 'fr') {
                $('.error-add2').text("Veuillez entrer votre deuxième adresse.");
             }
          	add2flag=1;
        }
    	else
        {
			jQuery('.error-add2').hide();
        	jQuery('#AddressAddress2New').removeClass('input--error');
        }
    	if(city == "")
        {
        	jQuery('.error-city').show();
          	jQuery('#AddressCityNew').addClass('input--error');
          	jQuery('.error-city').text("Please enter your city.");
            if ($('html').attr('lang') == 'de') {
                $('.error-city').text("Bitte geben Sie Ihre Stadt ein.");
             }
            if ($('html').attr('lang') == 'fr') {
                $('.error-city').text("Veuillez entrer votre ville.");
             }

          	cityflag=1;
        }
    	else
        {
			jQuery('.error-city').hide();
        	jQuery('#AddressCityNew').removeClass('input--error');
        }
    	if(zip == "")
        {
        	jQuery('.error-zip').show();
          	jQuery('#AddressZipNew').addClass('input--error');
          	jQuery('.error-zip').text("Please enter your zip code.");
            if ($('html').attr('lang') == 'de') {
                $('.error-zip').text("Bitte geben Sie Ihre Postleitzahl ein.");
             }
            if ($('html').attr('lang') == 'fr') {
                $('.error-zip').text("S'il vous plait, entrer votre code postal.");
             }
          	zipflag=1;
        }
    	else
        {
			jQuery('.error-zip').hide();
        	jQuery('#AddressZipNew').removeClass('input--error');
        }
    	
    	if(phone == "")
        {
        	jQuery('.error-phone').show();
          	jQuery('#AddressPhoneNew').addClass('input--error');
          	jQuery('.error-phone').text("Please enter your phone number.");
            if ($('html').attr('lang') == 'de') {
                $('.error-phone').text("Bitte gib deine Telefonnummer ein.");
             }
          if ($('html').attr('lang') == 'fr') {
                $('.error-phone').text("Veuillez entrer votre numéro de téléphone.");
             }
          	phoneflag=1;
        }
    	else
        {
			jQuery('.error-phone').hide();
        	jQuery('#AddressPhoneNew').removeClass('input--error');
        }
    	
    	
    	if(fflag==1 || lflag==1 || addflag==1 || add2flag==1 || cityflag==1 || zipflag==1 || phoneflag==1 )
        {
            
        	jQuery('.error-all').show();
          	jQuery('.error-all').html("One or more fields have an error. Please check and try again.");
          	if ($('html').attr('lang') == 'de') {
                $('.error-all').text("Ein oder mehrere Felder weisen einen Fehler auf. Bitte prüfen und erneut versuchen.");
             }
            if ($('html').attr('lang') == 'fr') {
                $('.error-all').text("Un ou plusieurs champs contiennent une erreur. S'il vous plaît, vérifiez et essayez à nouveau.");
             }
            return false;
        }
    	else
        {
        	jQuery('.error-all').hide();
          	return true;
        }
  });
  
  jQuery('.add-cancle-address-form').on('click',function(){

    jQuery('.error-all').hide();
    jQuery('#AddressPhoneNew').removeClass('input--error');
    jQuery('.error-phone').hide();
    jQuery('#AddressZipNew').removeClass('input--error');
    jQuery('.error-zip').hide();
    jQuery('#AddressCityNew').removeClass('input--error');
    jQuery('.error-city').hide();
    jQuery('#AddressAddress2New').removeClass('input--error');
    jQuery('.error-add2').hide();
    jQuery('#AddressAddress1New').removeClass('input--error');
    jQuery('.error-add1').hide();
    jQuery('#AddressLastNameNew').removeClass('input--error');
    jQuery('.error-lname').hide();
    jQuery('#AddressFirstNameNew').removeClass('input--error'); 
    jQuery('.error-fname').hide();
    jQuery('html').removeClass('open_address');
  });  
  
  
  
  jQuery('.new_address_button').on('click', function () {
    jQuery('html').addClass('open_address');
	});
  
  
//------------------ Forgot Page Breadcrumb --------------------//
  
  		// BEFORE "forgot_pass_page" CLASS ADDED
      	if (jQuery('html').attr('lang') == 'de') {
     	 	 jQuery('.login-text').html("Setze dein Passwort zurück");
          	}
      
       if (jQuery('html').attr('lang') == 'fr') {
     	 	 jQuery('.login-text').html("Réinitialisez votre mot de passe");
          	}
  
       if (jQuery('html').attr('lang') == 'de') {
                     jQuery('.login-text').html("EINLOGGEN");
              }
       if (jQuery('html').attr('lang') == 'fr') {
                     jQuery('.login-text').html("ANMELDUNG");
                  }

   
    
  
  
  setTimeout(function(){
	jQuery('#RecoverPassword').on('click', function () {
      
      // AFTER "forgot_pass_page" CLASS ADDED
		jQuery('body').addClass('forgot_pass_page');
		if (jQuery('body').hasClass('forgot_pass_page')) {
			jQuery('.login-text').html("Reset Your Password");
		
			if (jQuery('html').attr('lang') == 'de') {
     	 	 jQuery('.login-text').html("Setze dein Passwort zurück");
          	}
          
          
          if (jQuery('html').attr('lang') == 'fr') {
     	 	 jQuery('.login-text').html("Réinitialisez votre mot de passe");
          	}
		}
	});


   jQuery('.remove-reset').on('click', function () {
     
		jQuery('body').addClass('forgot_pass_page');
		if (jQuery('body').hasClass('forgot_pass_page')) {
			jQuery('.login-text').html("Login");
          
          if (jQuery('html').attr('lang') == 'de') {
                 jQuery('.login-text').html("EINLOGGEN");
          }
          
          if (jQuery('html').attr('lang') == 'fr') {
                 jQuery('.login-text').html("ANMELDUNG");
              }
          
          
		}
	});
   },600);
  
  
  
 

 
  
  //---------------------- tabbing on product detail ----------------------//
  
  
 $('ul.tabs').each(function(){

 	var active, content, links = $(this).find('a');
 	active = links.first().addClass('active');
 	content = $(active.attr('href'));
	links.not(':first').each(function () {

 	$($(this).attr('href')).hide();

 	});

 	$(this).find('a').click(function(e){

 	active.removeClass('active');
 	content.hide();
 	active = $(this);
 	content = $($(this).attr('href'));
 	active.addClass('active');
 	content.show();
 	return false;

 	});

 });

 
    //========================== toggle password  ==========================//

	jQuery(".toggle-password").on('click', function () {

		jQuery(this).toggleClass("fa-eye fa-eye-slash");
		var input = jQuery(jQuery(this).attr("toggle"));
		if (input.attr("type") == "password") {

			input.attr("type", "text");
		} else {

			input.attr("type", "password");
		}
	});
  
  
  //-------------------- Register validation ---------------------

  jQuery('.block-form-register .reg_btn').on('click',function(){
    jQuery('.reg-email-msg').hide();
    var fname=jQuery('.block-form-register #FirstName').val();
    var lname=jQuery('.block-form-register #LastName').val();
    var email=jQuery('.block-form-register #Email').val();
    var password=jQuery('.block-form-register #RegisterForm-password').val();
    var confirePassword=jQuery('.block-form-register #CreateconfirmPassword').val();
    var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var fflag,lflag,emailflag,passflag,conformpass = 0; 
    var con_passwd_err =0;
    if(fname == "")
    {
      jQuery('.block-form-register #FirstName').addClass('input--error');
      jQuery('.error-fname').show();
      jQuery('.error-fname').text('Please enter your first name.');
       if ($('html').attr('lang') == 'de') {
               $('.error-fname').text("Bitte geben Sie Ihren Vornamen ein.");
        	}
       if ($('html').attr('lang') == 'fr') {
                $('.error-fname').text("Entrez votre prénom s'il vous plait");
           }
      fflag=1;
    }
    else
    {	
      jQuery('.block-form-register #FirstName').removeClass('input--error');
      jQuery('.error-fname').hide();
    }
    if(lname == "")
    {
      jQuery('.block-form-register #LastName').addClass('input--error');
      jQuery('.error-lname').show();
      jQuery('.error-lname').text('Please enter your last name.');
       if ($('html').attr('lang') == 'de') {
               $('.error-lname').text("Bitte geben Sie ihren Nachnamen ein.");
        	}
       if ($('html').attr('lang') == 'fr') {
               $('.error-lname').text("Veuillez entrer votre nom de famille.");
        	}
      lflag=1;
    }
    else
    {	
      jQuery('.block-form-register #LastName').removeClass('input--error');
      jQuery('.error-lname').hide();
    }
    if(email == '')
    {
      emailflag=1;
      jQuery('.error-email').show();
      jQuery('.block-form-register #Email').addClass('input--error');
      jQuery('.error-email').text('Please enter your email address.');
      if ($('html').attr('lang') == 'de') {
               $('.error-email').text("Geben Sie bitte Ihre Email-Adresse ein.");
        	}
      if ($('html').attr('lang') == 'fr') {
               $('.error-email').text("Veuillez saisir votre adresse e-mail.");
        	}
    }
    else
    {
      if(!test_pattern.test(email))
      {
        emailflag=1;
        jQuery('.error-email').show();
        jQuery('.block-form-register #Email').addClass('input--error');
        jQuery('.error-email').text('The email address entered is invalid.');
        if ($('html').attr('lang') == 'de') {
               $('.error-email').text("Die eingegebene E-Mail-Adresse ist ungültig.");
        	}
        if ($('html').attr('lang') == 'fr') {
               $('.error-email').text("L'adresse e-mail saisie est invalide");
        	}
      }
      else
      {
        jQuery('.error-email').hide();
        jQuery('.block-form-register #Email').removeClass('input--error');
      }
    }
    if(password == "")
    {
      passflag = 1;
      jQuery('.block-form-register #RegisterForm-password').addClass('input--error');
      jQuery('.error-password').show();
      jQuery('.error-password').text('Please enter your password.');
       if ($('html').attr('lang') == 'de') {
               $('.error-password').text("Bitte geben Sie Ihr Passwort ein.");
        	}
        if ($('html').attr('lang') == 'fr') {
               $('.error-password').text("s'il vous plait entrez votre mot de passe");
        	}
    }
    else
    {	
      jQuery('.block-form-register #RegisterForm-password').removeClass('input--error');
      jQuery('.error-password').hide();
    }
    if(confirePassword == "")
    {
      conformpass = 1;
      jQuery('.block-form-register #CreateconfirmPassword').addClass('input--error');
      jQuery('.error-passwordbest').show();
      jQuery('.error-passwordbest').text('Please enter your confirm password');
      //console.log("hi");
      if ($('html').attr('lang') == 'de') {
               $('.error-passwordbest').text("Bitte geben Sie Ihr Bestätigungspasswort ein.");
        	}
        if ($('html').attr('lang') == 'fr') {
               $('.error-passwordbest').text("Veuillez entrer votre mot de passe de confirmation.");
        	}
    }
    else
    {
      if(password != confirePassword)
      { 
        jQuery('.block-form-register #CreateconfirmPassword').addClass('input--error');
        jQuery('.block-form-register #CreateconfirmPassword').addClass('input--error');
        jQuery('.error-passwordbest').text("Password Doesn't Match");
        con_passwd_err = 2;
        //console.log("123");
        if ($('html').attr('lang') == 'de') {
               $('.error-passwordbest').text("Passwort stimmt nicht überein.");
        	}
        if ($('html').attr('lang') == 'fr') {
               $('.error-passwordbest').text("Le mot de passe ne correspond pas.");
        	}
      }
      else
      {
        jQuery(".block-form-register #CreateconfirmPassword").removeClass('input--error');
        con_passwd_err = 0;       
        jQuery('.block-form-register #CreatePassword').removeClass('input--error');           
        jQuery('.error-passwordbest').hide();
      }
    }
    if(fflag == 1 || lflag == 1 || emailflag == 1 || conformpass == 1  || con_passwd_err == 2)
    {
      jQuery('.error-all').show();
      jQuery('.error-all').text('One or more fields have an error. Please check and try again.');
       if ($('html').attr('lang') == 'de') {
               $('.error-all').text("Ein oder mehrere Felder weisen einen Fehler auf. Bitte prüfen und erneut versuchen.");
        	}
      if ($('html').attr('lang') == 'fr') {
               $('.error-all').text("Un ou plusieurs champs contiennent une erreur. S'il vous plaît, vérifiez et essayez à nouveau.");
        	}
      return false;
    }
    else
    {
      jQuery('.error-all').hide();
      return true;
    }
  });
  
  
  
  
  
  //-------------------login-form & reset validation -------------------//
  
  
  
  jQuery('#login-form-full-wrap .login_btn_submit').on('click',function(){
    	jQuery('.errors').hide();
    	jQuery('.sent-msg').hide();
        var email=jQuery('#login-form-full-wrap #CustomerEmail').val();
    	var pass=jQuery('#login-form-full-wrap #CustomerPassword').val();
        var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    	var emailflag=0,passflag=0;
    	if(email == '')
        {
            emailflag=1;
          	jQuery('.error-email').show();
        	jQuery('#CustomerEmail').addClass('input--error');
          	jQuery('.error-email').text('Please enter your email address.');
            if ($('html').attr('lang') == 'de') {
               $('.error-email').text("Geben Sie bitte Ihre Email-Adresse ein.");
        	}
            if ($('html').attr('lang') == 'fr') {
                $('.error-email').text("Veuillez saisir votre adresse e-mail.");
             }
        }
    	else
        {
        	  if(!test_pattern.test(email))
            {
                emailflag=1;           
                jQuery('.error-email').show();
                jQuery('#CustomerEmail').addClass('input--error');
                jQuery('.error-email').text('Please enter your valid email.');
              if ($('html').attr('lang') == 'de') {
                 $('.error-email').text("Bitte geben Sie Ihre gültige E-Mail-Adresse ein.");
            	}
              if ($('html').attr('lang') == 'fr') {
                $('.error-email').text("veuillez entrer une adresse email valide.");
             }
              
            }
          	else
            {
            	jQuery('.error-email').hide();
                jQuery('#CustomerEmail').removeClass('input--error');
            }
        }
    	if(pass == '')
        {
             passflag=1;
          	 jQuery('.error-pass').show();
        	 jQuery('#login-form-full-wrap #CustomerPassword').addClass('input--error');
          	 jQuery('.error-pass').text('Please enter your password');
             if ($('html').attr('lang') == 'de') {
                $('.error-pass').text("Bitte geben Sie Ihr Passwort ein.");
             }
             if ($('html').attr('lang') == 'fr') {
                $('..error-pass').text("s'il vous plait entrez votre mot de passe");
             }
        }
    	else
        {
        	 jQuery('.error-pass').hide();
        	 jQuery('#login-form-full-wrap #CustomerPassword').removeClass('input--error');
        }
    	if(passflag == 1 || emailflag == 1 )
        {
        	 jQuery('.error-all').show();
        	 jQuery('.error-all').text('One or more fields have an error. Please check and try again.');
             if ($('html').attr('lang') == 'de') {
               $('.error-all').text("Ein oder mehrere Felder weisen einen Fehler auf. Bitte prüfen und erneut versuchen.");
        	}
             if ($('html').attr('lang') == 'fr') {
               $('.error-all').text("Un ou plusieurs champs contiennent une erreur. S'il vous plaît, vérifiez et essayez à nouveau.");
        	}
          return false;
        }
    	else
        {
        	jQuery('error-all').hide();
          	return true;
        }
  
  });
  
  
  jQuery('#recoverpassword-form .recover-submit-btn').on('click',function(){
    
    var email=jQuery('#recoverpassword-form #RecoverEmail').val();
  	var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var flag = 0;
    if(email == '')
        {
            flag = 1;
          	jQuery('.error-recover_email').show();
        	jQuery('#RecoverEmail').addClass('input--error');
          	jQuery('.error-recover_email').text('Please enter your email address.');
          if ($('html').attr('lang') == 'de') {
               $('.error-recover_email').text("Geben Sie bitte Ihre Email-Adresse ein.");
        	}
            if ($('html').attr('lang') == 'fr') {
                $('.error-recover_email').text("Veuillez saisir votre adresse e-mail.");
             }
        }
    	else
        {
        	  if(!test_pattern.test(email))
            {
                flag = 1;           
                jQuery('.error-recover_email').show();
                jQuery('#RecoverEmail').addClass('input--error');
                jQuery('.error-recover_email').text('Please enter your valid email.');
               if ($('html').attr('lang') == 'de') {
                 $('.error-recover_email').text("Bitte geben Sie Ihre gültige E-Mail-Adresse ein.");
            	}
              if ($('html').attr('lang') == 'fr') {
                $('.error-recover_email').text("veuillez entrer une adresse email valide.");
             }
            }
          	else
            {
            	jQuery('.error-recover_email').hide();
                jQuery('#RecoverEmail').removeClass('input--error');
            }
        }
    if (flag == 1) {
			return false;
		} else {
			return true;
		}
    
  });
  
  
  
  
  
 //----------------------- Contact form validation(Contact page) -------------------//
 
    
  
  	$(".contact_btn").click(function(e)
    {
      jQuery('.success-msg').hide();
        var email = jQuery('#ContactForm-email').val();
		var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var flag = 0;
    
      if($("#ContactForm-name").val()=='')
      {	
          jQuery('#ContactForm-name').addClass('input--error');
          $('.input-name').text('Please enter your first name');  
          if ($('html').attr('lang') == 'de') {
               $('.input-name').text("Bitte geben Sie Ihren Vornamen ein.");
          }
          if ($('html').attr('lang') == 'fr') {
               $('.input-name').text("Entrez votre prénom s'il vous plait");
          }
          flag =1;
      }
      else
      {
          $('.input-name').text(''); 
        jQuery('#ContactForm-name').removeClass('input--error');
		
      }
      if($("#ContactForm-email").val()=='')
      {
          jQuery('#ContactForm-email').addClass('input--error');
          $('.input-email').text('Please enter an email address'); 
          if ($('html').attr('lang') == 'de') {
               $('.input-email').text("Geben Sie bitte Ihre Email-Adresse ein.");
          }
          if ($('html').attr('lang') == 'fr') {
               $('.input-email').text("Entrez une adresse mail s'il vous plaît");
          }
          flag =1;
      }
      else
      {
        
        if (!test_pattern.test(email)) {
				 flag =1;
				jQuery('#ContactForm-email').addClass('input--error');
				jQuery('.input-email').text('Please enter valid email address.');
                if ($('html').attr('lang') == 'de') {
                 $('.input-email').text("Bitte geben Sie Ihre gültige E-Mail-Adresse ein.");
            	}
                if ($('html').attr('lang') == 'fr') {
                 $('.input-email').text("Veuillez saisir une adresse e-mail valide.");
                }
			} else {

				$('.input-email').text('');
        jQuery('#ContactForm-email').removeClass('input--error');
			}	
          
      }  
            if($("#ContactForm-phone").val()=='')
      {
          jQuery('#ContactForm-phone').addClass('input--error');
          $('.input-phone').text('Please enter your phone number ');
          if ($('html').attr('lang') == 'de') {
                $('.input-phone').text("Bitte geben Sie Ihre Kontaktnummer ein.");
             }
          if ($('html').attr('lang') == 'fr') {
                 $('.input-phone').text("Veuillez entrer votre numéro de téléphone.");
             }
          flag =1;
      }
      else
      {
          $('.input-phone').text(''); 
        jQuery('#ContactForm-phone').removeClass('input--error');
      }  

      if($("#ContactForm-message").val()=='')
      {
        jQuery('#ContactForm-message').addClass('input--error');
          $('.input-msg').text('Please enter your message');
          if ($('html').attr('lang') == 'de') {
               $('.input-msg').text("Bitte gib deine Nachricht ein.");
        	}
        if ($('html').attr('lang') == 'fr') {
               $('.input-msg').text("Veuillez entrer votre message.");
             }
         flag =1;
           	
      }     
      else
        {
          $('.input-msg').text('');
          jQuery('#ContactForm-message').removeClass('input--error');
          
        }
    if(flag == 1)
        {
          	
        	jQuery('.error-all').show();
          	jQuery('.error-all').text('One or more fields have an error. Please check and try again.');
        	if ($('html').attr('lang') == 'de') {
               $('.error-all').text("Ein oder mehrere Felder weisen einen Fehler auf. Bitte prüfen und erneut versuchen.");
        	}
            if ($('html').attr('lang') == 'fr') {
               $('.error-all').text("Un ou plusieurs champs contiennent une erreur. S'il vous plaît, vérifiez et essayez à nouveau.");
        	}
            return false;
        }
    	else
        {
        	jQuery('.error-all').hide();
          	return true;
        }
    
    
    });  
  
  
//.................... bottom-top button ................//

  jQuery(window).scroll(function(){

    if (jQuery(this).scrollTop() > 50) {


      jQuery('.top').fadeIn();

      jQuery('.top').addClass('show');
      jQuery('.top').removeClass('hide');

    } else {

      jQuery('.top').addClass('hide');
      jQuery('.top').removeClass('show');
      jQuery('.top').fadeOut();
    }

  });
  //Click event to scroll to top
  jQuery('.top').hide();	
  jQuery('.top').on("click",function(){
    jQuery('html, body').animate({scrollTop : 0},800);
    return false;
  });
  
  
  //------------------ Sticky-header --------------------//
  
  
  jQuery(window).scroll(function(){
        var sticky = jQuery('body'),
        scroll = jQuery(window).scrollTop();
    
        if(scroll>=15) sticky.addClass('sticky-header');
        else sticky.removeClass('sticky-header');
        });


//------------------- Add Focus in form ------------------//
  
  jQuery('input, select, textarea,email,password,tel').each(
		function(index){  
			var input = jQuery(this);
          	input.on('focus', function() {
                jQuery(this).parent().addClass("has-focus");
            });
          
          input.on('focusout', function() {
              if(jQuery(this).val() == '') {
                  jQuery(this).parent().removeClass("has-focus");
              }
		   }); 
          
    });
  
   jQuery('input[type="text"],input[type="email"],input[type="password"],input[type="tel"],input[type="search"], select, textarea').each(
          function(index){  
              var input = jQuery(this);
              if(input.val()=='')
              {
                  jQuery(input).parent().removeClass("has-focus");

              }else
              {                                                                                                                                                   
                  jQuery(input).parent().addClass("has-focus");	
              }
              //console.log('Type: ' + input.attr('type') + 'Name: ' + input.attr('name') + 'Value: ' + input.val());
      });
  

	//jQuery('#insta-feed').addClass('owlCarousel');

//  	jQuery('#insta-feed').owlCarousel({
// 	    loop:true,
// 	    margin:0,
// 	    dots: true,
//   		loop:true,
// 	    responsive:{
// 		0:{
// 		items:3
// 		},
// 		480:{
// 		items:3
// 		}
// 		}
// 	});
  jQuery('.contact_btn').click(function(){
   jQuery('.form-status-list').hide();
  });

});